/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import CourseSessionsManagementDash from "../../components/CourseSessionsManagement";
import Navbar from "../../components/Navbar";
import { backendUrlByEnv, LOGIN } from "../../constants/routes";

const CourseSessionsManagement = () => {
  const navigate = useNavigate();
  const { config: userConfig, env } = useSelector((state) => state?.reducer?.authInfo) || {};

  const ROOT_URL = backendUrlByEnv(env);

  useEffect(() => {
    // Support both old liveSessions and new courseSessions access config keys
    const hasAccess =
      userConfig?.courseSessions?.hasAccess || userConfig?.liveSessions?.hasAccess;
    if (!hasAccess) {
      navigate(LOGIN);
    }
  }, []);

  return (
    <>
      <Navbar />
      <CourseSessionsManagementDash userConfig={userConfig} ROOT_URL={ROOT_URL} />
    </>
  );
};

export default CourseSessionsManagement;
